//import {detect} from 'detect-browser';
import Component from '../abstracts/Component';
import ResetPwLogic from '../businessLogic/ResetPwLogic';

export default class AccountLayerComponent extends Component {

    get SELECTORS() {
        return {
            main: '.jsLoginSwitcher',
            header: '#header-account',
            loginForm: '#login-form',
            recoveryForm:'#recovery-form',
            activeForms: '.show-form',
            accountLayer:'[data-menu-layer="account"]',
            infoPennyPoint: '[data-componentpb="InfoPennyPoint"]'
        };
    }

    constructor() {
        super();
        this.showForm = 'show-form';
    }

    observerAttribute(mutationList,observer){
        for(let mutation of mutationList){
            if(mutation.type === 'attributes'){
                let attrSelector;
                let isLogged = mutation.target.dataset.logged;

                if(mutation.attributeName === 'data-logged'){

                    attrSelector = mutation.attributeName;
                    let iconsLogged = document.querySelectorAll(`button[${attrSelector}]`);

                    for(let icon of iconsLogged){
                        icon.dataset.logged = isLogged;
                    }
                }
            }
        }
    }
    initMutationObserver(){
        let accountLayer = document.querySelector(this.SELECTORS.accountLayer);
        let config = {
            childList : false,
            attributes: true,
            subtree:true
        };
        let observer = new MutationObserver(this.observerAttribute);
        observer.observe(accountLayer,config);
    }
    checkLogged(){
        let layer = document.querySelector(this.SELECTORS.accountLayer);
        if(layer.dataset.logged==='true'){
            this.setLoggedIcons('data-logged',true)
        }
    }
    setLoggedIcons(attrSelector,isLogged){
        let iconsLogged = document.querySelectorAll(`button[${attrSelector}]`);

        for(let icon of iconsLogged){
            icon.dataset.logged = isLogged;
        }
    }
    initSwitcher(classSelector){
        let elements = document.querySelectorAll(classSelector);
        for(let el of elements){
            el.addEventListener('click',()=>{
                this.hideForms();
                let formName = el.dataset.targetForm;
                this.switchForm(formName)
            })
        }

    }
    hideForms(){
        let activeForms = document.querySelectorAll(this.SELECTORS.activeForms);
        for(let activeForm of activeForms){
            activeForm.classList.remove(this.showForm);
            if(activeForm.classList.contains(this.showForm)){
                activeForm.classList.remove(this.showForm);
            }
            return '';
        }
    }
    switchForm(targetForm){
        let form = document.getElementById(targetForm);

        let titleForm = form.dataset.title;
        this.setTitle(titleForm);
        form.classList.add(this.showForm);
    }
    setTitle(title){
        let header = document.querySelector(this.SELECTORS.header);
        header.dataset.titleHeader = title;
    }

    showInfoPennyPointTooltip() {
      const infoPennyPoint = document.querySelector(this.SELECTORS.infoPennyPoint);
      const pennyPointPopup = document.querySelector(".c-penny-point-popup");
      const ctx = this;
      $(infoPennyPoint).on('click', function(e) {
        e.preventDefault();
        if(pennyPointPopup.classList.contains("d-none")) {
          pennyPointPopup.classList.remove("d-none");
        } else {
          pennyPointPopup.classList.add("d-none");
        }
      });
    }

    render() {
        this.log('Rendering...');
        this.ResetPwLogic = new ResetPwLogic(this);
   	    this.ResetPwLogic.render();
   	    this.showInfoPennyPointTooltip();
        if (document.querySelectorAll(this.SELECTORS.main).length){
            this.initSwitcher(this.SELECTORS.main);
        }
        if (document.querySelectorAll(this.SELECTORS.accountLayer).length){
            this.initMutationObserver();
            this.checkLogged();
        }
    }
}
